import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import "../../../../../assets/sass/_common.scss";
import Select from "react-select";
import HttpService from "../../../../../services/HttpService";
import { withRouter } from "react-router";

class LocationForm extends Component {
  state = {
    site: []
  }
  async getLookUp() {
    this.setState({ site: await HttpService.getSitesList() });
  }
  componentDidMount() {
    this.getLookUp();

  }

  handelGoBack = () => {
    const { history } = this.props;
    history.goBack();
  };
  render() {
    const {
      selectedLocationInfo,
      onFormFieldChange,
      onSave,
      onBranchChange,
      selectedBranch,
      validateLocation,
      onLocationUpdate,
    } = this.props;
    const {
      name,
    } = selectedLocationInfo;

 
    const {
      invalidname,
      invalidbranch
    } = validateLocation;
    return (
      <div>
        <div className="content">
          <Row>
            <Col lg="12" md="12" sm="12">
              <Card className="card-user">

                <CardBody>
                  <Form>
                    <Row>
                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <label className="form-label required">
                            {"Location"}
                          </label>
                          <Input
                            type="text"
                            autoFocus={invalidname}
                            className={`input-text-field  form-label" ${invalidname ? "inValid" : ""
                              }`}
                            name="name"
                            value={name}
                            onChange={onFormFieldChange}
                            maxLength={"20"}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <label className="form-label required">{"Branch"}</label>
                          <Select
                            name="branch"
                            className={`select-input  ${
                              invalidbranch ? "inValid" : ""
                            }`}
                            placeholder={"Select a Branch"}
                            value={selectedBranch}
                            onChange={(selectedOption, name) =>
                              onBranchChange(selectedOption, name)
                            }
                            options={this.state.site}
                           />
                        </FormGroup>
                      </Col>

                    </Row>

                    <Row>
                      <Col md={4} lg={3} sm={12} xs={12}>
                        <Button
                          className="mb-3 btn-block"
                          outline
                          color="primary"
                          onClick={() => this.handelGoBack()}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col lg={6} md={4} sm={12} xs={12} />
                      <Col lg={3} sm={12} md={4} xs={12}>
                        {this.props.formLocationAdd ?
                          <Button
                            className="btn-round btn-block float-right  "
                            color="primary"
                            onClick={() => onLocationUpdate()}
                            type="button"
                          >
                            Update Location

                          </Button>
                          :
                          <Button
                            className="btn-round btn-block float-right  "
                            color="primary"
                            onClick={() => onSave()}
                            type="button"
                          >
                            Add Location
                          </Button>
                        }
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}



export default (withRouter(LocationForm));
